<!-- 设置用户权限 -->
<template>
   <div>
      <el-dialog id="qx" :visible.sync="dataActionBox.showStatus" title="设置用户权限" append-to-body center :close-on-click-modal="false" width="80%" top="1rem">
         <el-form ref="form" inline class="form" label-width="110px" size="mini">
            <el-row style="padding: 10px 0;">
               <el-form-item label="申请人">
                  <el-input style="width: 200px;" clearable v-model="sendDataInfo.opmName" @keyup.enter.native="openSearch(8820873997127681, '', 'opmId', 'opmId,opmName,remark')"
                            :disabled="$store.getters.getUserInfo.opmAdmin == 0">
                     <el-button @click="openSearch(8820873997127681,'','opmId','opmId,opmName,remark')" slot="append" icon="el-icon-search" :disabled="$store.getters.getUserInfo.opmAdmin == 0">
                     </el-button>
                  </el-input>
               </el-form-item>
               <el-form-item label="申请岗位名称">
                  <el-input style="width: 200px;" placeholder="输入申请岗位名称" v-model="sendDataInfo.gpmRemark" :disabled="sendDataInfo.opmId != ''||sendDataInfo.opmName != '' ">
                  </el-input>
               </el-form-item>
               <el-form-item label="权限模板">
                  <el-select style="width: 200px;" v-model="templateInfo" multiple collapse-tags clearable placeholder="选择模板">
                     <el-option v-for="(tempValue, tempKey) in dataList" :key="tempKey" :label="tempValue.jteName" :value="tempValue.jteId">
                     </el-option>
                  </el-select>
               </el-form-item>
               <el-form-item label="备注">
                  <el-input style="width: 200px;" placeholder="备注" v-model="sendDataInfo.remark">
                  </el-input>
               </el-form-item>
            </el-row>
         </el-form>
         <el-tabs tab-position="left" type="border-card" :stretch="false" v-model="activeName" @tab-click="handleClick" style="height: 400px;overflow-y: auto;">
            <el-tab-pane v-for="(menuOne, menuOneKey) in menuList" :label="menuOne.label" :key="menuOneKey" style="height: 380px;overflow: auto;">
               <keep-alive>
                  <el-tree ref="menuTree" :data="[menuOne]" :show-checkbox="true" :check-strictly="true" @check="handleCheckChange" :expand-on-click-node="false" node-key="jurId" :props="defaultProps" highlight-current
                           :default-expanded-keys="[menuOne.jurId]">
                  </el-tree>
               </keep-alive>
            </el-tab-pane>
         </el-tabs>
         <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="dataActionBox.showStatus = false">取消</el-button>
            <el-button type="primary" @click="saveUserJurisdiction()">保存</el-button>
         </div>
      </el-dialog>
      <el-dialog :title="seTitle" v-if="dialogVisible" :visible.sync="dialogVisible" :width="seWidth" :modal-append-to-body="true" :append-to-body="true">
         <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
      </el-dialog>
   </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../byComponents/SearchScheme.vue"

export default {
   name: "settingJurisdictionApply",
   //import引入的组件需要注入到对象中才能使用
   components: { SearchScheme },
   data() {
      //这里存放数据
      return {
         jurisdictionShow: window.global_config.jurisdictionShow,
         dataActionBox: {
            showStatus: false,
            openMode: "ltr" || "rtl",
            boxTitle: "新增" || "编辑",
            actionType: 0, // 0新增，1修改
         },
         dialogVisible: false,
         parentSearchData: {},
         filterText: "",
         defaultProps: {
            children: "children",
            label: "label",
         },
         menuList: [],

         // 用户新权限
         userJurisdiction: [],
         dataList: [],
         userInfo: {},

         templateInfo: [],
         userJurisdictionDefault: {},
         sendDataInfo: {
            opmId: "",
            opmName: "",
            gpmId: "",
            gpmRemark: "",
            powerDetailAdds: [],
            remark: "",
            templateIds: "",
         },
         allMenuList: [],
         activeName: "",
         tabIndex: 0,
         nodeData: [],
         seTitle: "",
         seId: 0,
         seWidth: "0",
      }
   },
   //监听属性 类似于data概念
   computed: {},
   //监控data中的数据变化
   watch: {
      templateInfo: {
         handler: function (newValue, oldValue) {
            if (newValue.length > 0 && newValue != "") {
               var info = []
               newValue.forEach(val => {
                  var arr=this.dataList.filter(item=>item.jteId==val)
                  info.push(...arr[0].jurtemre)
               })
               info = [...new Set(info)]
               this.userJurisdiction = info
               this.$nextTick(() => {
                  this.menuList.forEach((item, index) => {
                     this.$refs.menuTree[index].setCheckedKeys(this.userJurisdiction)
                  })
               })
            } else {
               this.userJurisdiction = []
               this.$nextTick(() => {
                  this.menuList.forEach((item, index) => {
                     this.$refs.menuTree[index].setCheckedKeys(this.userJurisdiction)
                  })
               })
            }
         },
         deep: true,
      },
      tabIndex: {
         handler: function (newValue, oldValue) {
            this.nodeData[oldValue] = this.$refs.menuTree[
               oldValue
            ].getCheckedNodes()
            // this.$refs.menuTree[index].setCheckedKeys(sendDataInfo)
         },
         deep: true,
      },
      "dataActionBox.showStatus"() {
         if (this.dataActionBox.showStatus) {
            setTimeout(() => {
               this.$nextTick(() => {
                  this.menuList.forEach((item, index) => {
                     this.$refs.menuTree[index].setCheckedKeys([])
                  })
               })
               if (this.dataActionBox.actionType == 1) {
                  this.$nextTick(() => {
                     this.menuList.forEach((item, index) => {
                        this.$refs.menuTree[index].setCheckedKeys([])
                        this.$refs.menuTree[index].setCheckedKeys(this.userJurisdiction)
                     })
                  })
               }
            }, 16.7)
         }
      },
      "sendDataInfo.opmName": {
         handler: function (newValue, oldValue) {
            if (newValue == "") {
               this.sendDataInfo.opmId = ""
            }
         },
      },
   },
   //方法集合
   methods: {
      // 赋值字段
      paramValue(val) {
         let arr = this.sField.split(",")
         arr.forEach((item) => {
            this.sendDataInfo[item] = val[item]
         })
      },
      changeInputModel(val) {
         if (val != "" || val != undefined) {
            this.dialogVisible = false
            this.paramValue(val)
            this.sendDataInfo.gpmRemark = val.opmJob
            this.sendDataInfo.remark = val.remark
         }

         this.getUserJurisdiction(this.sendDataInfo.opmId)
      },
      getSeWidth(e) {
         this.seWidth = e + "%"
      },
      getWidth(e) {
         this.exWidth = e + "%"
      },
      getSearchName(e) {
         this.seTitle = e
      },
      openSearch(sId, index, type, sField) {
         this.dialogVisible = true
         this.seId = sId
         this.seIndex = index
         this.seType = type
         this.sField = sField
         this.parentSearchData[type] = this.sendDataInfo[type]
      },
      // tree 发生点击 变化时
      // 统一处理子节点为相同的勾选状态
      uniteChildSame(treeList, isSelected) {
         if (isSelected) {
            this.userJurisdiction.push(treeList.jurId)
         } else {
            this.userJurisdiction.forEach((item, index) => {
               if (item == treeList.jurId) {
                  this.userJurisdiction.splice(index, 1)
               }
            })
         }
         this.$refs.menuTree[this.tabIndex].setChecked(treeList.jurId, isSelected)
         if (!treeList.children) return
         for (let i = 0; i < treeList.children.length; i++) {
            this.uniteChildSame(treeList.children[i], isSelected)
         }
      },
      // 统一处理父节点为选中
      selectedParent(currentObj) {
         let currentNode = this.$refs.menuTree[this.tabIndex].getNode(currentObj)
         if (currentNode.parent.key !== undefined) {
            if (!this.userJurisdiction.includes(currentNode.parent.data.jurId))
               this.userJurisdiction.push(currentNode.parent.data.jurId)
            this.$refs.menuTree[this.tabIndex].setChecked(currentNode.parent, true)
            this.selectedParent(currentNode.parent)
         }
      },
      handleCheckChange(currentObj, treeStatus) {
         console.log(currentObj, treeStatus)
         this.$refs.menuTree[this.tabIndex].getCheckedNodes()
         // 用于：父子节点严格互不关联时，父节点勾选变化时通知子节点同步变化，实现单向关联。
         let selected = treeStatus.checkedKeys.indexOf(currentObj.jurId) // -1未选中,>=0为选中
         // 选中
         if (selected !== -1) {
            // 子节点只要被选中父节点就被选中(需要选中父节点时候调用此方法)
            this.selectedParent(currentObj)
            // 统一处理子节点为相同的勾选状态
            this.uniteChildSame(currentObj, true)
         } else {
            this.userJurisdiction.forEach((item, index) => {
               if (item == currentObj.jurId) {
                  this.userJurisdiction.splice(index, 1)
               }
            })
            // 未选中 处理子节点全部未选中
            if (!currentObj.children) return
            if (currentObj.children.length !== 0) {
               this.uniteChildSame(currentObj, false)
            }
         }
      },
      handleClick(tab, event) {
         console.log(this.activeName)
         this.tabIndex = Number(tab.index)
         this.$refs.menuTree[this.tabIndex].setCheckedKeys(this.userJurisdiction)
      },
      handleCheckAllChange(levOne, levTwo) { },
      // 获取权限
      async getJurisdictionList() {
         let responseData = await this.$http.getJurisdictionList({ jurType: 0 }) //权限类型权限类型0.erp1.协同
         if (responseData.status == 200) {
            this.allMenuList = responseData.result
            this.menuList = this.handleJurisdiction(responseData.result)
            console.log("this.menuList", this.menuList)
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            })
         }
      },

      // 获取用户权限
      async getUserJurisdiction(opmId) {
         let responseData = await this.$http.getUserJurisdiction({
            jurType: 0, //	权限类型权限类型0.erp1.协同
            opmId: opmId, //	id列表
         })
         if (responseData && responseData.status && responseData.status == 200) {
            this.jurisdictionSettingBox = true
            var selectedList = []
            console.log("用户权限", responseData.result)
            responseData.result.forEach((item) => {
               selectedList.push(item.jurId)
            })
            this.userJurisdictionDefault = selectedList
            this.userJurisdiction = selectedList
            this.$nextTick(() => {
               console.log(this.$refs.menuTree)
               this.menuList.forEach((item, index) => {
                  this.$refs.menuTree[index].setCheckedKeys([])
                  this.$refs.menuTree[index].setCheckedKeys(this.userJurisdiction)
               })
            })
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            })
         }
      },

      // 保存人员权限
      async saveUserJurisdiction() {
         if (this.sendDataInfo.gpmRemark == "") {
            return this.$message({
               message: "请输入申请岗位名称",
               type: "error",
            })
         }
         this.sendDataInfo.powerDetailAdds = []
         this.userJurisdiction = [...new Set(this.userJurisdiction)]
         this.allMenuList.forEach((item) => {
            for (let index = 0; index < this.userJurisdiction.length; index++) {
               if (item.jurId == this.userJurisdiction[index]) {
                  this.sendDataInfo.powerDetailAdds.push({
                     jurId: item.jurId,
                     jurParentid: item.jurParentid,
                     gpdName: item.jurName,
                  })
               }
            }
         })
         this.sendDataInfo.templateIds = this.templateInfo.join()
         var responseData
         if (this.dataActionBox.actionType == 1) {
            responseData = await this.$http.setAuthorityApply(this.sendDataInfo)
         } else {
            responseData = await this.$http.addAuthorityApply(this.sendDataInfo)
         }
         if (responseData.status == 200) {
            this.$message({
               message: "保存成功",
               type: "success",
            })
            this.$parent.getDataList()
            this.dataActionBox.showStatus = false
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            })
         }
      },

      // 权限处理
      handleJurisdiction(data, id = 0, lev = 0) {
         var son = []
         data.forEach((value, keys) => {
            value["selectedStatus"] = false
            this.userJurisdiction.forEach((userValue, userKeys) => {
               if (value["jurId"] == userValue["jurId"]) {
                  value["selectedStatus"] = true
                  if (this.jurisdictionShow) {
                     value["disabled"] = true
                  } else {
                     value["disabled"] = false
                  }
               }
            })
            if (value["jurParentid"] == id) {
               value["id"] = value["jurId"]
               value["value"] = value["jurId"]
               value["label"] = value["jurName"]
               if (this.jurisdictionShow) {
                  value["disabled"] = true
               } else {
                  value["disabled"] = false
               }
               var list = this.handleJurisdiction(data, value["jurId"], lev + 1)
               if (list.length >= 1) {
                  value["children"] = this.handleJurisdiction(
                     data,
                     value["jurId"],
                     lev + 1
                  )
               }

               son.push(value)
            }
         })
         return son
      },

      openBox(oldData, cate, gpmRemark, opmName, remark, gpmId, opmId, templateIds) {
         this.userJurisdiction = []
         this.sendDataInfo.gpmRemark = ""
         this.sendDataInfo.opmName = ""
         this.sendDataInfo.opmId = ""
         this.sendDataInfo.remark = ""
         if (cate == 1) {
            oldData.forEach((item) => {
               this.userJurisdiction.push(item.id)
            })
            var flag = true
            this.menuList.forEach((item, index) => {
               oldData.forEach((item1) => {
                  if (flag) {
                     if (item.id === item1.jurParentid) {
                        flag = false
                        this.activeName = String(index)
                     }
                  }
               })
            })
            this.sendDataInfo.gpmRemark = gpmRemark
            this.sendDataInfo.opmName = opmName
            this.sendDataInfo.remark = remark
            this.sendDataInfo.opmId = opmId
            this.sendDataInfo.gpmId = gpmId
            this.sendDataInfo.templateIds = ""
               this.templateInfo = []
            if (templateIds) {
               this.sendDataInfo.templateIds = templateIds
               this.templateInfo = templateIds.split(',').map(item=>Number(item))
            }
         } else {
            if (!this.$store.getters.getUserInfo.opmAdmin) {
               this.sendDataInfo.gpmRemark = this.$store.getters.getUserInfo.opmJob
               this.sendDataInfo.opmName = this.$store.getters.getUserInfo.opmName
               this.sendDataInfo.opmId = this.$store.getters.getUserInfo.opmId
               this.getUserJurisdiction(this.sendDataInfo.opmId)
            }
         }
         this.dataActionBox.actionType = cate
         this.dataActionBox.showStatus = true
      },

      // 获取模板
      async getDataList() {
         let responseData = await this.$http.getJurisdictionTemplate()
         if (responseData && responseData.status == 200) {
            this.dataList = responseData.result
            this.selectedDataIndex = 0
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            })
         }
      },
   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      this.getJurisdictionList()
      this.getDataList()
   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() { },
   beforeCreate() { }, //生命周期 - 创建之前
   beforeMount() { }, //生命周期 - 挂载之前
   beforeUpdate() { }, //生命周期 - 更新之前
   updated() { }, //生命周期 - 更新之后
   beforeDestroy() { }, //生命周期 - 销毁之前
   destroyed() { }, //生命周期 - 销毁完成
   activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
#qx ::v-deep .el-tabs--border-card {
   margin-bottom: 0px !important;
}
#qx ::v-deep .el-tabs__header {
   height: 100% !important;
}
::v-deep .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
   background-color: #409eff;
   border-color: #409eff;
}
::v-deep .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
   border-color: #fff;
}
/* .form ::v-deep .el-tabs--left .el-tabs__nav-wrap.is-left.is-scrollable{
  height: 400px;
} */
</style>
<style>
/* .el-cascader .el-cascader__tags {
   max-height: 300px !important;
   overflow-y: scroll !important;
}

.jurisdiction_box_one {
   padding: 1rem;
}

.jurisdiction_one {
   width: 100%;
   margin-bottom: 0.2rem;
}

.jurisdiction_three_box {
   padding: 0.5rem 0;
} */
</style>
